
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/credits",
      function () {
        return require("private-next-pages/my-account/credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/credits"])
      });
    }
  